import React from "react";

const OptionButton = ({ option, label, onClick, disabled = false }) => {
  // Special styling for Yes/No buttons
  const isYesNoButton = option === "Yes" || option === "No";

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`option-button ${isYesNoButton ? "yes-no-button" : ""}`}
    >
      <div className="flex items-center justify-between">
        {/* label may differ from the value sent to the backend */}
        <span className="truncate">{label || option}</span>
        <svg
          className="w-4 h-4 text-gray-400 flex-shrink-0 ml-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>
    </button>
  );
};

export default OptionButton;
